import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import baseUrl from '~/services/base';
import { apiExtrato, apiSaldo, apiGrupos, apiLucree } from '../services/api';
import TipoPerfil from '../assets/styles/payloadsExtratoExcel/perfilParticipante.json';
import TipoPerfilIndustria from '../assets/styles/payloadsExtratoExcel/perfilIndustria.json';
import TipoPerfilExtrato from '../assets/styles/payloadsExtratoExcel/perfilExtrato.json';
import PayloadLancamentosIndustria from '../assets/styles/payloadsPedidosExcel/perfilIndustria.json';
import TipoExtratoIndustria from '../assets/styles/payloadsExtratoExcel/perfilExtratoIndustria.json';



export const ExtratoContext = createContext([]);

export function ExtratoProvider(props) {
	const { children, user } = props;
	const [loadingSaldo, setLoadingSaldo] = useState(false)
	const [totalItems, setTotalItems] = useState(0);
	const [dataSaldo, setDataSaldo] = useState({
		total_venda: '',
		saldo_bruto: '',
		saldo_liquido: '',
		credito: '',
		debito: '',
		saldo: '',
	});
	const [dataExtrato, setDataExtrato] = useState([]);
	const [revendaHierarquiaList, setRevendaHierarquiaList] = useState([]);
	const [dataExtratoIndustria, setDataExtratoIndustria] = useState([]);
	const [loadingExtrato, setLoadingExtrato] = useState(true);
	const [origemConcatenada, setOrigemConcatenada] = useState([]);
	const [totalCreditados, setTotalCreditados] = useState(0);
	const [totalDebitados, setTotalDebitados] = useState(0);
	const [totalCredito, setTotalCredito] = useState(0);

	const [loadingSaldoDisponivel, setLoadingSaldoDisponivel] = useState(false);
	const [montanteDestinatario, setMontanteDestinatario] = useState(0);

	let callingRelacoes = false;
    let callingExtrato = false;

	async function authToken() {
		try {
			const credentials = {
				username: 'daniel.nascimento',
				password: 'acessoLucree#2018',
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);

			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}

		return null;
	}

	async function getExtrato(documento, page, filtroData, filtroTipo, filtroPesquisa, revenda, filtroDocRevenda = '', items = 10) {
		if (callingExtrato) return;
		callingExtrato = true;

		setLoadingExtrato(true)
		const cargo = user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria' ? 'participante' : 'revenda';
		var tipo = '';
		const origem = revenda !== '' ? `&distribuidor_id=${revenda}` : '';
		var docRevenda = '';

		if (filtroTipo.creditados === true && filtroTipo.debitados === false) {
			tipo = '&tipo=CR'
		} else if (filtroTipo.creditados === false && filtroTipo.debitados === true) {
			tipo = '&tipo=DB'
		} else {
			tipo = ''
		}

		if(cargo === 'participante' && filtroDocRevenda){
			docRevenda = `&revenda=${filtroDocRevenda}`
		}

		try {
			await apiExtrato.get(`${cargo}/${documento}?page=${page}&items=${items}${filtroData}${tipo}${origem}${docRevenda}`, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token.access}`,
				},
			}).then((res) => {
				setTotalDebitados(res.data.total_creditados || 0)
				setTotalCreditados(res.data.total_debitados || 0)
				setTotalCredito(res.data.total_credito || 0)
				setLoadingExtrato(false)
				setTotalItems(res.data.total_registros)
				setDataExtrato(res.data.dados ? res.data.dados : []);
			});
		} catch (error) {
			setLoadingExtrato(false)
			toast.error(
				'Os extratos não foram carregados. Por favor atualize a página.'
			);
		} finally {
			callingExtrato = false;
 		}
	}

	async function getExtratoIndustria(filtroData, filtroPesquisa, page, items = 10 ) {
		if (callingExtrato) return;
		callingExtrato = true;

		try {
			await apiExtrato.get(`industria?items=${items}&page=${page}&busca=${filtroPesquisa.trim()}${filtroData}`, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token.access}`,
				},
			}).then((res) => {
				setTotalDebitados(res.data.total_creditados || 0)
				setTotalCreditados(res.data.total_debitados || 0)
				setTotalCredito(res.data.total_credito || 0)
				setLoadingExtrato(false)
				setTotalItems(res.data.total_registros)
				setDataExtratoIndustria(res.data.dados ? res.data.dados : []);
			});
		} catch (error) {
			setLoadingExtrato(false)
			toast.error(
				'Os extratos não foram carregados. Por favor atualize a página.'
			);
		} finally {
			callingExtrato = false;
 		}
	}


	const getExportLancamentos = useCallback(
		async (filtroData, filtroPesquisa, filtroRevendaHierarquia = '') => {
			try {
				const dataPath = '.lancamentos';
				let url = '';
				var docRevenda = '';
				if(filtroRevendaHierarquia){
					docRevenda = `&revenda=${filtroRevendaHierarquia}`
				}

				// Condicional Url
				url = `${baseUrl.pgm}/lancamentos?busca=${filtroPesquisa}${filtroData}&excel=true${docRevenda}`;

				const payload = {
					logo: 'lucree',
					sheet_name: 'Planilha Lucree',
					request: {
						data_path: dataPath,
						url: url,
						headers: {
							Authorization: `Bearer ${user.token.access}`,
						},
					},
					styles: [
						{
							name: "bold",
							bold: true
						},
						{
							name: "date",
							num_format: "DD/MM/YYYY"
						},
						{
							name: "money",
							num_format: "#,##0.00;[RED]-#,##0.00"
						}
					],
					format: PayloadLancamentosIndustria, // Acessando dicionário dentro do Json TipoPerfil
				};

				download(payload);
			} catch (error) {
				// setLoadingExtrato(false);
				// eslint-disable-next-line no-console
				console.log('Erro no Download Export, extrato.');
			}
		},
		[user.dados.lojista_id, user.dados.tipo_cliente]
	);

	const getExportExtrato = useCallback(
		async (page, documento, filtroData, filtroTipo, params, revenda, filtroRevendaHierarquia = '') => {
			try {
				const dataPath = '.dados';
				let url = '';
				const cargo = user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria' ? 'participante' : 'revenda';
				var tipo = '';
				var docRevenda = '';

				if (filtroTipo.creditados === true && filtroTipo.debitados === false) {
					tipo = '&tipo=CR'
				} else if (filtroTipo.creditados === false && filtroTipo.debitados === true) {
					tipo = '&tipo=DB'
				} else {
					tipo = ''
				}


				if(cargo === 'participante' && filtroRevendaHierarquia){
					docRevenda = `&revenda=${filtroRevendaHierarquia}`
				}

				const origem = revenda !== '' ? `&distribuidor_id=${revenda}` : '';

				// Condicional Url
				if (user.dados.cargo.toLowerCase() !== 'industria') {
					url = `${baseUrl.pgm}/extrato/${cargo}/${documento}?page=${page}${filtroData}${tipo}${origem}${docRevenda}`;
				}

				// url = 'https://pjfc7azioi.execute-api.us-west-2.amazonaws.com/preprod/pedidos';
				const payload = {
					logo: 'lucree',
					sheet_name: 'Planilha Lucree',
					request: {
						data_path: dataPath,
						url: url,
						headers: {
							Authorization: `Bearer ${user.token.access}`,
						},
						params: {
							items: 15000,
							init_date: params.dateInit,
							end_date: params.dateEnd
						},
					},
					styles: [
						{
							name: "bold",
							bold: true
						},
						{
							name: "date",
							num_format: "DD/MM/YYYY"
						},
						{
							name: "money",
							num_format: "#,##0.00;[RED]-#,##0.00"
						}
					],
					format: TipoPerfilExtrato, // Acessando dicionário dentro do Json TipoPerfil
				};

				download(payload);
			} catch (error) {
				setLoadingExtrato(false);
				// eslint-disable-next-line no-console
				console.log('Erro no Download Export, extrato.');
			}
		},
		[user.dados.lojista_id, user.dados.tipo_cliente]
	);

	const getExportIndustria = useCallback(
		async (filtroData, filtroPesquisa) => {
			try {
				const dataPath = '.dados';
				let url = '';
				url = `${baseUrl.pgm}/extrato/industria?items=5000&page=1&excel=true&busca=${filtroPesquisa}${filtroData}`;

				const payload = {
					logo: 'lucree',
					sheet_name: 'Planilha Lucree',
					request: {
						data_path: dataPath,
						url: url,
						headers: {
							Authorization: `Bearer ${user.token.access}`,
							'Content-Type': 'application/json'
						},
					},
					"styles": [
						{
							"name": "bold",
							"bold": true
						},
						{
							"name": "date",
							"num_format": "DD/MM/YYYY"
						},
						{
							"name": "money",
							"num_format": "#,##0.00;[RED]-#,##0.00"
						}
					],
					format: TipoExtratoIndustria, // Acessando dicionário dentro do Json TipoPerfil
				};

				download(payload);
			} catch (error) {
				setLoadingExtrato(false);
				// eslint-disable-next-line no-console
				console.log('Erro no Download Export, extrato.');
			}
		},
		[user.dados.lojista_id, user.dados.tipo_cliente]
	);

	async function getSaldoDisponivel(documento) {
		try {
			await apiSaldo.get(`${documento}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}).then((res) => {
					setMontanteDestinatario(res.data.saldo);
					setLoadingSaldoDisponivel(false);
					return res
				})
		} catch (error) {
			setMontanteDestinatario(0);
			setLoadingSaldoDisponivel(false);
			console.log('Erro na verificação de saldo disponível.');
		}
		return null;
	}


	async function getSaldo(documento, distribuidor, filtroData = '') {
		// const distribuidorId = (distribuidor || distribuidor !== '') ? `?distribuidor_id=${distribuidor}` : '';

		if (filtroData.length > 0){
			if (filtroData.includes('hoje')) {
				const today = new Date();
				const year = today.getFullYear();
				const month = String(today.getMonth() + 1).padStart(2, '0');
				const day = String(today.getDate()).padStart(2, '0');

				const formattedDate = `${year}-${month}-${day}`;
				filtroData = `&data_lancamento=${formattedDate}%7C${formattedDate}`
			}


			if (filtroData.includes('semana')) {
				const today = new Date();
				const year = today.getFullYear();
				const month = String(today.getMonth() + 1).padStart(2, '0');
				const day = String(today.getDate()).padStart(2, '0');

				const formattedDate = `${year}-${month}-${day}`;

				const sevenDays = new Date();
				sevenDays.setDate(sevenDays.getDate() - 7);

				const sevenDaysYear = sevenDays.getFullYear();
				const sevenDaysMonth = String(sevenDays.getMonth() + 1).padStart(2, '0');
				const sevenDaysDay = String(sevenDays.getDate()).padStart(2, '0');

				const formattedSevenDate = `${sevenDaysYear}-${sevenDaysMonth}-${sevenDaysDay}`;


				filtroData = `&data_lancamento=${formattedSevenDate}%7C${formattedDate}`
			}

			if(!distribuidor && filtroData){
				filtroData = `?${filtroData.slice(1)}`;
			}
		}

		setLoadingSaldo(true)
		try {
			const response = await apiSaldo.get(`${documento}${distribuidor ? `?distribuidor_id=${distribuidor}` : ''}${filtroData}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,
					},
				}).then((res) => {
					setDataSaldo(res.data);
					setLoadingSaldo(false);
					return res;
				})

			return response;
		} catch (error) {
			setLoadingSaldo(false)
			if (error.response) {
				if(error?.response?.data?.dados){
					setDataSaldo(error?.response?.data?.dados);
				}
			}
		}
		return null;
	}

	async function getGrupo(lojistaId) {
		try {
			const credentials = {
				username: 'daniel.nascimento',
				password: 'acessoLucree#2018',
			};

			const { data } = await apiLucree.post(
				`autenticacao/v1/`,
				credentials
			);

			await apiGrupos
				.get(`/api/lojista/${lojistaId}`, {
					headers: {
						'Content-Type': 'application/json',
						Authorization: data.id_token,
					},
				})
				.then((res) => {
					getOrigem(data.id_token, res.data.data[0].grupo_nome);
				});
		} catch (error) {
			console.log('Os dados do lojista não foram carregados.', error);
		}
	}


	async function getHierarquiaByDoc(doc) {
		if (callingRelacoes) return;
		callingRelacoes = true;
	
		let ultimosDescendentes = false;

		if(user.dados.cargo.toLowerCase() === 'distribuidor - matriz' || user.dados.cargo.toLowerCase() === 'industria'){
			ultimosDescendentes = true;
		}

		await authToken().then(async (response) => {
			if(response.data.id_token){
				try {
					await apiLucree
						.get(`/hierarquiav2/relacoes-por-nivel/${doc}/?autoinclusao=false&level=abaixo&ultimos_descendentes=${ultimosDescendentes}`, {
							headers: {
								'Content-Type': 'application/json',
								Authorization: response.data.id_token,
							},
						}).then((res) => {
							if(res.data.envolvidos){
								setRevendaHierarquiaList(res.data.envolvidos)
							} else {
								setRevendaHierarquiaList([])
							}
						}).catch((error) => {
							console.log(error)
							setRevendaHierarquiaList([])
						});
				} catch (error) {
					console.log('Os dados do lojista não foram carregados.', error);
				} finally {
					callingRelacoes = false;
				}
			}
		}).catch((error) => {
			console.log('Os dados do lojista não foram carregados.', error);
		});
		
	}

	async function getOrigem(token, grupoNome) {
		try {
			const arrayConcatenarGrupo = [];

			await apiGrupos
				.get(`/api/grupos/${grupoNome}`, {
					headers: {
						'Content-Type': 'application/json',
						Authorization: token,
					},
				})
				.then((res) => {
					const { tree } = res.data.data;
					const { root } = res.data.data;

					// Titular (Pai)
					arrayConcatenarGrupo.push({
						id: root,
						grupo: tree[root].sub,
					});
					// eslint-disable-next-line array-callback-return
					Object.entries(tree[root].children).map((key) => {
						// Filhos
						arrayConcatenarGrupo.push({
							id: key[0],
							grupo: key[1].sub,
						});
					});

					setOrigemConcatenada(arrayConcatenarGrupo);
				});
		} catch (error) {
			console.log('Os dados do grupo não foram carregados.', error);
		}
	}

	/**
	 * Excel Extrat
	 */

	function download(data) {
		var oReq = new XMLHttpRequest();
		oReq.open(
			'POST',
			'https://api.grupoe2f.com.br/export/export',
			true
		);
		oReq.responseType = 'blob';
		oReq.setRequestHeader('Content-Type', 'application/json');

		const link = document.createElement('a');

		oReq.onload = function () {
			var blob = oReq.response;
			link.setAttribute('download', 'extratoLucree.xlsx');
			link.href = URL.createObjectURL(blob);
			link.setAttribute('href', URL.createObjectURL(blob));
			document.body.appendChild(link);
			link.click();

			setLoadingExtrato(false);
		};

		oReq.send(JSON.stringify(data));
	}

	const getExport = useCallback(
		async (page, documento, filtroData, filtroTipo, params, filtroRevendaHierarquia = '') => {
			const industria = user.dados.cargo.toLowerCase() === 'industria';
			try {
				const dataPath = '.dados';
				let url = '';
				const cargo = user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria' ? 'participante' : 'revenda';
				var tipo = '';
				var docRevenda = '';
				if (filtroTipo.creditados === true && filtroTipo.debitados === false) {
					tipo = '&tipo=CR'
				} else if (filtroTipo.creditados === false && filtroTipo.debitados === true) {
					tipo = '&tipo=DB'
				} else {
					tipo = ''
				}

				if(cargo === 'participante' && filtroRevendaHierarquia){
					docRevenda = `&revenda=${filtroRevendaHierarquia}`
				}

				// Condicional Url
				url = `${baseUrl.pgm}/extrato/${cargo}/${documento}?page=${page}${filtroData}${tipo}${docRevenda}`;


				// url = 'https://pjfc7azioi.execute-api.us-west-2.amazonaws.com/preprod/pedidos';
				const payload = {
					logo: 'lucree',
					sheet_name: 'Planilha Lucree',
					request: {
						data_path: dataPath,
						url: url,
						headers: {
							Authorization: `Bearer ${user.token.access}`,
						},
						params: {
							items: 15000,
							init_date: params.dateInit,
							end_date: params.dateEnd
						},
					},
					styles: [
						{
							name: "bold",
							bold: true
						},
						{
							name: "date",
							num_format: "DD/MM/YYYY"
						},
						{
							name: "money",
							num_format: "#,##0.00;[RED]-#,##0.00"
						}
					],
					format: industria ? TipoPerfilIndustria : TipoPerfil,
				};

				download(payload);
			} catch (error) {
				setLoadingExtrato(false);
				// eslint-disable-next-line no-console
				console.log('Erro no Download Export, extrato.');
			}
		},
		[user.dados.lojista_id, user.dados.tipo_cliente]
	);

	return (
		<ExtratoContext.Provider
			value={{
				authToken,
				loadingSaldo,
				totalItems,
				dataSaldo,
				dataExtrato,
				loadingExtrato,
				origemConcatenada,
				dataExtratoIndustria,
				loadingSaldoDisponivel,
				montanteDestinatario,
				revendaHierarquiaList,
				totalCreditados,
				totalDebitados,
				totalCredito,
				setDataExtrato,
				setMontanteDestinatario,
				setLoadingSaldoDisponivel,
				setLoadingExtrato,
				getGrupo,
				getOrigem,
				getExtrato,
				getExtratoIndustria,
				getSaldo,
				getSaldoDisponivel,
				getExport,
				getExportLancamentos,
				getExportIndustria,
				getExportExtrato,
				getHierarquiaByDoc
			}}>
			{children}
		</ExtratoContext.Provider>
	);
}
